import React from "react";
import { Container, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
	Heading,
	Text,
	List,
	Image,
	Gallery,
	Banner,
	Embed,
	Buttons,
	Video,
	CallToAction,
	ContactCard,
	Highlight,
	AnchorNav,
	TitleBar,
	Resources,
	FieldsDisplay,
	Divider,
	Orcid,
} from "./../../";

function Block(props) {
	const theme = useTheme();
	const { type, id, fullWidth, isSidebar } = props;
	const full_width_types = [
		"node--call_to_action",
		"node--embed_code",
		"node--heading",
		"node--banner_image",
	];
	let block;
	switch (type) {
		case "node--heading":
			block = fullWidth ? (
				<TitleBar title={props.title} align="center" headingType="h2" />
			) : (
				<Heading {...props}>{props.title}</Heading>
			);
			break;
		case "node--text":
			block = <Text html={props.text} />;
			break;
		case "node--image":
			block = <Image {...props} />;
			break;
		case "node--gallery":
			block = <Gallery {...props} />;
			break;
		case "node--entities_list":
			block = <List {...props} cols={isSidebar ? 1 : props.cols} />;
			break;
		case "node--banner_image":
			block = <Banner {...props} />;
			break;
		case "node--embed_code":
			block = <Embed {...props} />;
			break;
		case "node--buttons":
			block = <Buttons {...props} />;
			break;
		case "node--video":
			block = <Video {...props} />;
			break;
		case "node--call_to_action":
			block = <CallToAction {...props} />;
			break;
		case "node--contact_card":
			block = <ContactCard {...props} />;
			break;
		case "node--highlight":
			block = <Highlight {...props} />;
			break;
		case "node--anchor_links":
			block = <AnchorNav />;
			break;
		case "node--resources":
			block = <Resources {...props} />;
			break;
		case "node--fields_display":
			block = <FieldsDisplay {...props} />;
			break;
		case "node--separator":
		case "node--divider":
			block = <Divider className="separator" size="lg" />;
			break;
		case "node--orcid_id":
			block = <Orcid id={props.field_orcid_id} />;
			break;
		default:
			block = (
				<div>
					{type} {id}
				</div>
			);
			break;
	}
	if (!fullWidth || (fullWidth && full_width_types.includes(type))) {
		return block;
	} else {
		return (
			<Box
				className={`block-container block-type-${type} ${
					fullWidth ? "full-width" : ""
				}`}
			>
				<Container
					maxWidth={theme?.customOptions?.containerMaxWidth || "xl"}
					sx={(theme) => ({
						...(fullWidth && {
							marginTop: theme.spacing(3),
							marginBottom: theme.spacing(3),
						}),
					})}
				>
					{block}
				</Container>
			</Box>
		);
	}
}

export default Block;
